

export function getCredentialSubject(content: any): any {
    if(content.properties?.credentialSubject) {
        //console.log(content.properties);
        return content.properties.credentialSubject;
    }
    if(content.allOf) {
        const out = content.allOf.map((schema: any) => getCredentialSubject(schema)).filter((schema: any) => schema !== undefined)
        if(out.length > 0) {
            return out[0]
        }
    }
    if(content.anyOf) {
        const out = content.anyOf.map((schema: any) => getCredentialSubject(schema)).filter((schema: any) => schema !== undefined)
        if(out.length > 0) {
            return out[0]
        }
    }
    return undefined
}

export function makeValueOnSchema(content: any, withDescriptions?: boolean): any {
    switch(content.type) {
        case "string":
            return withDescriptions ? (content.description ? content.description : content.title): ""
        case "date":
            return new Date().toISOString()
        case "array":
            return [makeValueOnSchema(content.items, withDescriptions)];
        case "number":
            return 0 
        case "object":
            let out: any = {};
            Object.keys(content.properties).forEach(field => out[field] = makeValueOnSchema(content.properties[field], withDescriptions))
            return out
        default:
            throw "unknown schema type " + content.type         
    }
}